<div class="d-flex flex-column flex-wrap gap-1">
    <ng-container *ngFor="let n of names; let i = index">
        <div class="d-flex justify-content-start align-items-center gap-1">
            <strong>{{ n.name }}</strong
            >&nbsp;{{ n.value }}
        </div>
    </ng-container>
</div>
